// hooks

// libraries
import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import type { DealHistory, StateTree } from '@makemydeal/dr-dash-types';
import * as dealEffectiveSelectors from '@makemydeal/dr-dash-store/selectors/dealEffectiveSelectors';

import * as constants from '../../constants';
import DealSummaryItem from '../common/DealSummaryItem';

import { useDealSummary } from '../../common/DealSummaryProvider';
// styles
import { detailedViewValueStyles } from '../utils/styles';
import { useTrackedSelector } from '../../telemetry/useTrackedSelector';

const CashDown = ({ deal, hasDelta }: { deal?: DealHistory; hasDelta?: boolean }) => {
    const downPayment = useTrackedSelector((state: StateTree) => dealEffectiveSelectors.selectEffectiveDownPayment(state, deal), {
        component: 'CashDown',
        field: 'effectiveDownPayment'
    });
    const { showDetailedView } = useDealSummary();

    return (
        <DealSummaryItem
            label={constants.CASH_DOWN}
            value={formatDollarsAndCents(downPayment)}
            hasDelta={hasDelta}
            valueStyles={showDetailedView ? detailedViewValueStyles : {}}
        />
    );
};

export default CashDown;
